import { createAutoAnimatePlugin } from "@formkit/addons";
import { en, de } from "@formkit/i18n";

import { rootClasses } from "../formkit.theme.mjs";

const config = {
  locales: { en, de },
  locale: "en",
  config: {
    rootClasses: (sectionName, node) => {
      if (sectionName === "label" && node.props?.validation?.includes("required")) {
        return {
          ...rootClasses(sectionName, node),
          "after:content-['_*'] after:text-red-500 after:ml-0.5": true,
        };
      }

      return rootClasses(sectionName, node);
    },

    // This is only so until formkit gets updated to work properly - https://github.com/formkit/formkit/issues/1623
    sectionsSchema: {
      input: {
        attrs: {
          "aria-invalid": {
            if: "$state.validationVisible",
            then: "$state.invalid",
          },
        },
      },
    },
  },
  plugins: [
    (node) => {
      if (node.props.validation?.includes("required")) {
        node.props["label-class"] = "after:content-[' *']";
      }
    },
    createAutoAnimatePlugin(),
  ],
};

export default config;
